import qs from 'qs'

import { TABS } from 'components/pages/userPreferencePage/userPreferenceTabs'
import { USER_CALENDAR_PREFERENCE_URL } from 'qap/constants'

export const stringifyCalendarLink = () => `${USER_CALENDAR_PREFERENCE_URL}?${qs.stringify({ tabFilter: TABS[0].value })}`
